import { TextField, Typography } from "@material-ui/core"
import { useContext, useState } from "react"
import CounterHeader from "~/components/Common/CounterHeader"
import ClientContext from "~/contexts/Client"
import useOpenErrorSnackbar from "~/hooks/useOpenErrorSnackbar"
import Box from "../../Common/Box"
import useStyles from "./styles"

export default function AppTheme() {
  const { clientDetailsValues, client, setClientDetailsValues } =
    useContext(ClientContext)
  const classes = useStyles()
  const openErrorSnackbar = useOpenErrorSnackbar()
  const [jsonValue, setJsonValue] = useState(client?.app_theme || "")
  const [showError, setShowError] = useState(false)

  const onAppThemeJsonChange = (e) => {
    try {
      JSON.parse(jsonValue)
      setClientDetailsValues((oldState) => ({
        ...oldState,
        app_theme: jsonValue === "" ? null : jsonValue,
      }))
    } catch (error) {
      openErrorSnackbar(error, "Invalid theme JSON")
      setShowError(true)
    }
  }

  const handleChange = (newValue) => {
    setJsonValue(newValue)

    // Empty value is always valid
    if (newValue === "") {
      setShowError(false)
      setClientDetailsValues((oldState) => ({
        ...oldState,
        app_theme: null,
      }))
      return
    }

    try {
      JSON.parse(newValue)

      setShowError(false)
      setClientDetailsValues((oldState) => ({
        ...oldState,
        app_theme: newValue,
      }))
    } catch {
      setShowError(true)
    }
  }

  return (
    <>
      <Box marginTop="15px" marginBottom="15px">
        <hr />
      </Box>
      <Typography
        variant="h3"
        color="primary"
        className={classes.title}
        style={{ marginBottom: 10 }}
      >
        APP
      </Typography>
      <Box width="100%" marginTop="8px">
        <CounterHeader
          title="Subdomain"
          value={clientDetailsValues?.app_subdomain || ""}
          max={255}
        />
        <TextField
          value={clientDetailsValues?.app_subdomain || ""}
          onChange={(e) => {
            setClientDetailsValues((oldState) => ({
              ...oldState,
              app_subdomain: e.target.value === "" ? null : e.target.value,
            }))
          }}
          style={{ marginBottom: "10px" }}
          InputProps={{
            classes: {
              root: classes.inputBackgroundColor,
            },
          }}
          variant="filled"
          size="small"
          fullWidth
        />
      </Box>
      <Typography color="secondary" className={classes.inputLabel}>
        Theme
      </Typography>
      <TextField
        value={jsonValue}
        onChange={(e) => {
          const newValue = e.target.value
          handleChange(newValue)
        }}
        onBlur={onAppThemeJsonChange}
        multiline={true}
        minRows="10"
        style={{ marginBottom: "10px" }}
        InputProps={{
          classes: {
            root: classes.inputBackgroundColor,
          },
        }}
        variant="filled"
        size="small"
        fullWidth
      />
      {showError && <p className="text-red-500">Invalid theme JSON</p>}
      <CounterHeader
        title="Login URL"
        value={clientDetailsValues?.login_url || ""}
        max={255}
      />
      <TextField
        value={clientDetailsValues?.login_url || ""}
        onChange={(e) => {
          setClientDetailsValues((oldState) => ({
            ...oldState,
            login_url: e.target.value === "" ? null : e.target.value,
          }))
        }}
        style={{ marginBottom: "10px" }}
        InputProps={{
          classes: {
            root: classes.inputBackgroundColor,
          },
        }}
        variant="filled"
        size="small"
        fullWidth
      />
    </>
  )
}
